export enum JobStates {
    Processing = 'processing',
    NoJob = 'noJob',
    Failed = 'failed',
    Finished = 'finished',
}
